import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    color: 'white',
    maxWidth: '100%',
    fontSize: '.5rem',
  },
  media: {
    height: 0,
    paddingTop: '176.25%', // 16:9
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
